export const LAST_ACTIVITY_THRESHOLD = 1000 * 60 * 30; // 30 minutes
export const CHECK_ACTIVITY_INTERVAL = 1000 * 60 * 30; // 30 minutes

export const IDLE_TIMEOUT = 1000 * 60 * 60 * 8; // 8 hours

export const PROMPT_TIME = 1000 * 60 * 60 * 7.5; // 7.5 hours (when to show modal)

// App session activity monitoring
export const APP_SESSION_EXTEND_THROTTLE = 1000 * 60 * 3; // 3 minutes
export const APP_SESSION_IDLE_THRESHOLD = 1000 * 60 * 10; // 10 minutes
// Perf-only debounce for the raw activity listener (mousemove/keydown/etc).
// Must stay well below APP_SESSION_EXTEND_THROTTLE -- that's the actual
// business-rule gate inside evaluateAndAct, server-baseline aware. This one
// only limits how often we bother running that check at all.
export const APP_SESSION_ACTIVITY_CHECK_INTERVAL = 1000; // 1 second

// Shared by the broadcast hook and the module-level logout publisher, which
// must post on the same channel to reach other tabs.
export const APP_SESSION_BROADCAST_CHANNEL_NAME = 'app-session-channel';
